module.exports = __webpack_public_path__ + "media/images/floor_plan/chair-01e4a1170a8d60c484c30d1c96b90775.png";